// extracted by mini-css-extract-plugin
export default {"noPermissionWrapper":"Common_noPermissionWrapper__TFgkT"};